import React from 'react';
import { Typography } from '@mui/material';

function Text({ onClick, children, variant = 'body1', sx = {} }) {
  // Define which variants should be bold by default
  const headingVariants = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
  const isHeading = headingVariants.includes(variant);

  return (
    <Typography
      variant={variant}
      onClick={onClick}
      sx={{
        color: '#2A2A2A',
        fontWeight: isHeading ? 'bold' : 'normal',
        fontFamily: isHeading ? 'Poppins, sans-serif' : 'Roboto, sans-serif',
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}

export default Text;
